module.exports = __webpack_public_path__ + "static/media/The Girl in a Swing_main_t.a59ecdf4.jpg";